// 页面内容配置
const pageItems = require('./pageItems.config.js');
// 页面版本配置
const pageVersions = require('./pageVersions.config.json');

let pageList = pageItems;

if (process.env.DEVPAGE) {
  const devPages = process.env.DEVPAGE.split(','); // 本地调试，仅启动指定页面
  pageList = pageList.filter((item) => devPages.includes(item.name));
}

pageList = pageList.map((page) => {
  const versions = pageVersions[`mach_pro_sailor_${page.name}`] || {};
  return ({
    ...page,
    handle: {
      bundleName: `mach_pro_sailor_${page.name}`,
      bundleVersion: versions.version,
      versions,
    },
  });
});

// console.log('start pages:', pageList, pageList.length, process.env.DEVPAGE);

module.exports = pageList;
